module.exports = __webpack_public_path__ + "img/diversidad.0ccd9158.png";